import React from 'react';
import {CardContent, Paper} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {DeleteOutline} from "@mui/icons-material";
import ArrayShifter from "../../../adminPages/ArrayShifter";
import ImageLoader from "../../../components/imageLoader/ImageLoader";
import {Link} from "react-router";
import Button from "@mui/material/Button";

function OrderDesigns({images, withDeleteButton, removeImage, orderable, orderItem, clickable, withLink}) {
    const onImageClick = (src) => {
        window.open(src, '_blank').focus();
    }

    const getProductPictures = () => {
        return (images || []).map((item, index) => {
            return <Grid key={item.src} sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                pt: 2
            }}>
                <Paper>
                    <ImageLoader src={item.thumbnail || item.src}
                                 fallbackSrc={item.src}
                                 sx={{
                                     width: 64,
                                     height: 64,
                                     borderRadius: '5%',
                                     borderColor: 'secondary.main',
                                     cursor: clickable ? 'pointer' : 'inherit'
                                 }} onClick={clickable && (() => onImageClick(item.src))}/>
                    {withDeleteButton ? <CardContent className="" sx={{
                        width: 64,
                        height: 64,
                        borderRadius: '5%',
                        cursor: 'pointer',
                        backgroundColor: 'rgba(255,255,255,0.7)',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        opacity: 0,
                        "&:hover": {
                            opacity: 1,
                        }
                    }} onClick={() => removeImage(index)}>
                        <DeleteOutline
                            sx={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}
                            color="secondary"/>
                    </CardContent> : ''}
                    {withLink ?
                        <Button><Link to={item.src} target={'blank'} style={{textDecoration: 'none', color: 'inherit'}}>Open</Link></Button> : ''
                    }
                </Paper>
                {orderable ? <ArrayShifter index={index} shiftTo={orderItem} length={(images || []).length}/> : ''}
                {item.nr ? `x${item.nr}` : ''}
            </Grid>
        });
    }

    return (
        <Grid container gap={1}>{getProductPictures()}</Grid>
    );
}

export default OrderDesigns;
